var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[(_vm.getStartStatus)?_c('quiz-header'):_vm._e()],1),_c('div',{staticClass:"content"},[(_vm.getStartStatus)?_c('quiz-box'):_vm._e(),_c('div',{staticStyle:{"float":"none","clear":"both"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }